import { RemoteI9Details } from '@dtos/remote-i9-details';
import { OnboardingDetailsRequestEvent } from '@models/onboarding-review/onboarding-details-request-event';
import { IOnboardingDetailsRequestService } from '@services/onboarding-review/onboarding-details-request-service';
import { ISection2CertificationStore } from '@stores/onboarding-review/section2-certification-store';
import { Subscription } from 'rxjs';

export interface ISection2CertificationUpdater {
    initialise(): void;
    cleanup(): void;
}

/**
 * Logic layer entity that responds to onboarding details request events for certification store
 */
export class Section2CertificationUpdater implements ISection2CertificationUpdater {
    private requestEventSubscription: Subscription = Subscription.EMPTY;

    constructor(
        private store: ISection2CertificationStore,
        private onboardingDetailsRequestService: IOnboardingDetailsRequestService
    ) {
    }

    initialise(): void {
        this.requestEventSubscription = this.onboardingDetailsRequestService
            .requestEvents
            .subscribe(this.listenToRequestEvents);
    }

    cleanup(): void {
        this.requestEventSubscription.unsubscribe();
    }

    listenToRequestEvents = (event: OnboardingDetailsRequestEvent) => {
        if (event.type === 'pending') {
            this.handlePending();
            return;
        }

        if (event.type === 'success') {
            this.handleSuccess(event.dto);
            return;
        }
    };

    handlePending = () => {
        this.store.setFirstName('');
        this.store.setLastName('');
        this.store.setSignedOn('');
        this.store.setDidAgreeToSign(false);
        this.store.setBusinessAddress({
            city: '',
            state: '',
            streetAddress: '',
            zipCode: ''
        });
        this.store.setBusinessName('');
        this.store.setTitle('');
    };

    handleSuccess = ({ section2Details }: RemoteI9Details) => {
        if (!section2Details) {
            console.error('Request Events failed to validate dto');
            return;
        }

        this.store.setTitle(section2Details.title);
        this.store.setBusinessAddress(section2Details.organizationAddress);
        this.store.setBusinessName(section2Details.organizationName);
    };
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-certification-updater.ts